








































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import Spinner from '@/components/Spinner.vue';
import ConnectionErrorContent from '@/components/ConnectionErrorContent.vue';

export interface Recipe {
	id: string;
	title: string;
    image: boolean;
    forValue: number;
}

export interface Ingredient {
    quantity: string;
    unit: string;
    ingredient: string;
}

export interface ShoppingListRequest {
    id: string;
    forValue: number;
}

@Component({
  components: {
    Spinner,
    ConnectionErrorContent,
  },
})
export default class GroceryList extends Vue {

    private statusAll!: string;
    private statusList!: string;
    private recFilter!: string;
    private recipeListSelected!: Recipe[];
    private resetButton!: boolean;
    private shoppingList!: Ingredient[];

    private data() {
        return {
            statusAll: 'loading',
            statusList: '',
            recFilter: '',
            recipeListSelected: [],
            resetButton: false,
            shoppingList: [],
        };
    }

    private created() {
        this.$store.state.btnSidebarVisible = false;
        this.$store.state.headerNavVisible = false;
		this.loadData();
    }

    private loadData() {
        this.$store.dispatch('getRecipeList')
        .then((response) => {
            this.$store.state.recipeListShown = this.$store.state.recipeList.sort((a: any, b: any) => a.title.localeCompare(b.title));
            this.statusAll = 'success';
		}).catch((error) => {
            this.statusAll = 'error';
        });
    }

    private filterRecipes() {
        if (this.recFilter !== '') {
            this.resetButton = true;
        } else {
            this.resetButton = false;
        }
        const filter = this.recFilter.toUpperCase();
        const recipeList = this.$store.state.recipeList;
        this.$store.state.recipeListShown = [];

        for (let i = 0; i < recipeList.length; i++) {
            if (recipeList[i].title.toUpperCase().indexOf(filter) > -1) {
                this.$store.state.recipeListShown.push(recipeList[i]);
            }
        }
    }

    private resetFilter() {
        this.resetButton = false;
        this.recFilter = '';
        this.$store.state.recipeListShown = this.$store.state.recipeList;
    }

    private selectRecipe(recipe: Recipe) {
        let alreadyInList: boolean = false;
        for (let i = 0; i < this.recipeListSelected.length; i++) {
            if (this.recipeListSelected[i].id === recipe.id) {
                alreadyInList = true;
            }
        }
        if (!alreadyInList) {
            this.recipeListSelected.push(recipe);
        }
    }

    private deselectRecipe(id: string) {
        const recipeListSelectedNew: Recipe[] = [];
        for (let i = 0; i < this.recipeListSelected.length; i++) {
            if (id !== this.recipeListSelected[i].id) {
                recipeListSelectedNew.push(this.recipeListSelected[i]);
            }
        }
        this.recipeListSelected = recipeListSelectedNew;
    }

    private requestShoppingList() {
        this.statusList = 'loading';
        const request: ShoppingListRequest[] = [];
        for (let i = 0; i < this.recipeListSelected.length; i++) {
            request.push({id: this.recipeListSelected[i].id, forValue: +this.recipeListSelected[i].forValue});
        }
        this.$http.post('shoppinglist', request).then((response: AxiosResponse) => {
			this.shoppingList = response.data.map((val: any) => ({
                quantity: val.quantity,
                unit: val.unit,
                ingredient: val.ingredient,
            }));
            for (let i = 0; i < this.shoppingList.length; i++) {
                if (+this.shoppingList[i].quantity !== 0 && !isNaN(+this.shoppingList[i].quantity)) {
                    const quantity = +this.shoppingList[i].quantity;
                    this.shoppingList[i].quantity = quantity.toLocaleString('de-DE', {maximumFractionDigits: 2});
                }
            }
            this.statusList = 'success';
		}).catch((error) => {
            this.statusList = 'error';
        });
    }

    private copyShoppingList() {
        let text: string = '';
        for (let i = 0; i < this.shoppingList.length; i++) {
            if (this.shoppingList[i].quantity !== '') {
                text = text + this.shoppingList[i].quantity + ' ';
            }
            if (this.shoppingList[i].unit !== '') {
                text = text + this.shoppingList[i].unit + ' ';
            }
            if (this.shoppingList[i].ingredient !== '') {
                text = text + this.shoppingList[i].ingredient;
            }
            if (i < this.shoppingList.length - 1) {
                text = text + '\n';
            }
        }
        const dummy = document.createElement('textarea');
        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand('copy');
        document.body.removeChild(dummy);
        this.$store.state.infoBoxText = 'Ihre Einkaufsliste wurde in die Zwischenablage kopiert.';
    }

    private clearShoppingList() {
        this.shoppingList = [];
    }
}
